"use client";

import { ArrowRight, ChevronDown, Play, Radio, Trophy, Target, ChartBar as BarChart3 } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheLegendBegins() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const stats = [{
    label: "ARTIST",
    value: "GEORGE & DANIELLA",
    icon: Trophy
  }, {
    label: "Experience",
    value: "15+ Years of Mastery",
    icon: Target
  }, {
    label: "LOCATION",
    value: "PAPHOS",
    icon: BarChart3
  }];
  return <section data-section-id="623" id="the-legend-begins" className="relative bg-background text-foreground overflow-hidden min-h-[720px] h-screen w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698889/img/gothic_skull_background.png)] bg-cover bg-center">
      {}

      {}
      <div className="absolute inset-0 z-10 pointer-events-none" style={{
      background: "radial-gradient(ellipse at center, transparent 0%, hsla(0, 0%, 5%, 0.6) 40%, hsla(0, 0%, 5%, 0.98) 100%)"
    }} />

      {}
      <div className="absolute inset-0 z-10 pointer-events-none opacity-[0.08]" style={{
      backgroundImage: "repeating-linear-gradient(0deg, transparent, transparent 2px, hsl(0 100% 40%) 2px, hsl(0 100% 40%) 3px)"
    }} />

      {}
      <div className="absolute inset-0 z-10 pointer-events-none opacity-[0.06] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      {}
      <div className="absolute inset-x-0 top-0 h-32 z-10 pointer-events-none bg-gradient-to-b from-background/80 to-transparent" />

      {}
      <div className="relative z-20 h-full w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-end pb-20 sm:pb-24 lg:pb-32 pt-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end">
          {}
          <div ref={contentRef} className={`lg:col-span-8 transition-all duration-1000 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-6">
              <div className="relative w-4 h-4">
                <div className="absolute top-0 left-0 w-3 h-[2px] bg-primary" />
                <div className="absolute top-0 left-0 h-3 w-[2px] bg-primary" />
              </div>
              <span className="font-mono text-xs sm:text-sm uppercase tracking-widest text-primary">
                PAPHOS · CYPRUS
              </span>
            </div>

            {}
            <h1 className="font-default font-bold uppercase leading-[0.85] tracking-tight mb-8">
              <span className="block text-5xl sm:text-7xl lg:text-8xl xl:text-9xl text-foreground">
                WHERE INK
              </span>
              <span className="block text-5xl sm:text-7xl lg:text-8xl xl:text-9xl text-muted-foreground/70 ml-4 sm:ml-8 lg:ml-16">
                BECOMES
              </span>
              <span className="block text-5xl sm:text-7xl lg:text-8xl xl:text-9xl ml-8 sm:ml-16 lg:ml-32 bg-clip-text text-transparent animate-pulse-slow" style={{
              backgroundImage: "linear-gradient(90deg, hsl(0 100% 40%) 0%, hsl(0 100% 20%) 100%)"
            }}>
                LEGACY
              </span>
            </h1>

            {}
            <p className="font-default text-base sm:text-lg text-muted-foreground max-w-2xl mb-8 leading-relaxed">
              Premium gothic artistry by George. A sanctuary where luxury meets rock and roll, forging timeless masterpieces on skin.
            </p>

            {}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
              <Button asChild size="lg" className="group relative bg-primary text-primary-foreground hover:bg-primary/90 font-default uppercase tracking-widest text-sm font-bold px-8 h-14 shadow-lg rounded-md" style={{
              clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)"
            }}>
                <Link to="https://instagram.com/hardrockcytattoo">
                  <span className="relative flex h-2 w-2 mr-1">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-md bg-primary-foreground opacity-75" />
                    <span className="relative inline-flex rounded-md h-2 w-2 bg-primary-foreground" />
                  </span>
                  <Play className="w-4 h-4 fill-current" />
                  INSTAGRAM
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="group bg-transparent border-2 border-primary text-primary hover:bg-primary/10 hover:text-primary font-default uppercase tracking-widest text-sm font-bold px-8 h-14 rounded-md">
                <Link to="https://wa.me/35794043514">
                  WHATSAPP
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={statsRef} className={`lg:col-span-4 transition-all duration-1000 delay-300 ${statsVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="hidden lg:flex flex-col gap-3">
              {stats.map((stat, i) => {
              const Icon = stat.icon;
              return <Card key={i} data-index={i} className="relative bg-card/60 backdrop-blur-md border border-primary/30 p-4 rounded-md overflow-hidden">
                    {}
                    <div className="absolute top-1 left-1 w-3 h-3 border-t-2 border-l-2 border-primary" />
                    <div className="absolute top-1 right-1 w-3 h-3 border-t-2 border-r-2 border-primary" />
                    <div className="absolute bottom-1 left-1 w-3 h-3 border-b-2 border-l-2 border-primary" />
                    <div className="absolute bottom-1 right-1 w-3 h-3 border-b-2 border-r-2 border-primary" />

                    <div className="flex items-center justify-between gap-4 px-2">
                      <div className="flex items-center gap-3">
                        <div className="p-2 bg-primary/10 rounded-md">
                          <Icon className="w-4 h-4 text-primary" />
                        </div>
                        <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
                          {stat.label}
                        </span>
                      </div>
                      <span className="font-default text-2xl font-bold text-primary">
                        {stat.value}
                      </span>
                    </div>
                  </Card>;
            })}
            </div>

            {}
            <div className="grid grid-cols-3 gap-2 lg:hidden mt-4">
              {stats.map((stat, i) => {
              const Icon = stat.icon;
              return <Card key={i} data-index={i} className="relative bg-card/60 backdrop-blur-md border border-primary/30 p-3 rounded-md">
                    <div className="absolute top-1 left-1 w-2 h-2 border-t-2 border-l-2 border-primary" />
                    <div className="absolute bottom-1 right-1 w-2 h-2 border-b-2 border-r-2 border-primary" />
                    <div className="flex flex-col items-center gap-1 px-1">
                      <Icon className="w-3 h-3 text-primary" />
                      <span className="font-mono text-[8px] uppercase tracking-wider text-muted-foreground text-center">
                        {stat.label}
                      </span>
                      <span className="font-default text-lg font-bold text-primary">
                        {stat.value}
                      </span>
                    </div>
                  </Card>;
            })}
            </div>
          </div>
        </div>

      </div>

      {}
      <div className="absolute bottom-6 right-4 sm:right-6 lg:right-8 z-30 hidden sm:block">
        <Card className="bg-card/80 backdrop-blur-md border border-primary/40 p-2 rounded-md flex flex-row items-center gap-3 max-w-[240px]">
          <div className="relative w-16 h-12 rounded-md overflow-hidden bg-muted flex-shrink-0">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698889/img/hardrock_studio_preview.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698889/img/hardrock_studio_preview.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698889/img/hardrock_studio_preview.webp-wvc-sizes" alt="Studio preview" className="w-full h-full object-cover grayscale" loading="lazy" decoding="async" />
            <div className="absolute inset-0 bg-foreground/10" />
          </div>
          <div className="flex flex-col gap-1 pr-2">
            <Badge className="bg-primary text-primary-foreground font-mono text-[9px] uppercase tracking-widest px-1.5 py-0 h-4 gap-1 rounded-md">
              <Radio className="w-2 h-2 animate-pulse" />
              OPEN
            </Badge>
            <span className="font-mono text-[10px] uppercase tracking-wider text-foreground">
              BOOKING NOW
            </span>
          </div>
        </Card>
      </div>

      <style>{`
        @keyframes pulse-slow {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.85; }
        }
        @keyframes bounce-slow {
          0%, 100% { transform: translate(-50%, 0); }
          50% { transform: translate(-50%, 8px); }
        }
        .animate-pulse-slow {
          animation: pulse-slow 3s ease-in-out infinite;
        }
        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
      `}</style>
    </section>;
}